var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{attrs:{"icon":"fa fa-eye","size":"sm","flat":"","dense":"","title":"View web-based email"},on:{"click":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }